import { Routes, Route } from "react-router-dom";
import "./App.css";
import LoginAdmin from "./page/LoginAdmin";
import LoginUser from "./page/LoginUser";
import PanelLayout from "./layout/PanelLayout";
import AdminLayout from "./layout/AdminLayout";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LoginUser />} />
        <Route path="/login" element={<LoginUser />} />
        <Route path="/login-admin" element={<LoginAdmin />} />
        <Route path="/admin/*" element={<AdminLayout />} />
        <Route path="/*" element={<PanelLayout />} />
      </Routes>
    </div>
  );
}

export default App;
